const remoteAssistKey = 'RAYDIANT_REMOTE_ASSIST_USER';

export const getRemoteAssistUser = () => {
  return localStorage.getItem(remoteAssistKey);
};

export const setRemoteAssistUser = (email: string) => {
  return localStorage.setItem(remoteAssistKey, email);
};
